import { Component } from '@angular/core';

@Component({
  selector: 'xp-no-access-to-view',
  templateUrl: './no-access-to-view.component.html',
  styleUrl: './no-access-to-view.component.scss'
})
export class NoAccessToViewComponent {

}
